import React from 'react';

const ManageLabor = () => <h1 className="pageTitle">Labor</h1>;

export default ManageLabor;
